import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 12777 19489"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M369 14448c-249-576-432-4573 3-5008 275-276 1271 74 1536 567 447 832 106 1526 449 2429 328 866 884 670 1158-272 0 0 67-1156-22-1528-150-626-1131-4798-1575-6739-392-1713 767-2375 1133-1949 780 909 2801 8142 2801 8142l-356-2052c0-736 1913-373 2145 138l549 1914s-219-1260-219-1821c0-313 1462 26 1837 542 258 353 719 1279 719 1279s-361-1153-312-1228c112-173 1300 432 1685 999 1248 1838 891 3901 571 6123-229 1593-1087 2702-1555 3204-180 192-432 301-695 301H5333c-244 0-463-112-655-262-1861-1444-3405-2680-4309-4779z"
        className="fil0"
      />
      <path
        d="M1934 1979c226-282 535-451 828-451 204 0 386 81 513 228 318 371 802 1633 1283 3066 578-504 946-1244 946-2070C5504 1234 4269 0 2751 0 1234 0 0 1234 0 2752c0 1242 827 2293 1959 2634-124-533-237-1024-329-1423-247-1083 84-1708 304-1984z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
